import { call, put } from "redux-saga/effects";
import { push } from "connected-react-router";
import { Creators as MessagesCreators } from "../ducks/messages";
import { Creators as CreditCardCreators } from "../ducks/creditCard";
import { Creators as SubscriptionCreators } from "../ducks/subscription";

import api from "../../services/api";
import { siteParams } from '../../config/site';
import { formatter } from "../../services/apiResponseFormatter";
import { IS_APP } from "../../services/target";

export function* subscription({ payload }) {
  const url = payload.credit_card.newCard
    ? "/v2/credit_cards"
    : `/v2/subscriptions${
    payload.credit_card.campaign_id
      ? `/?campaign_id=${payload.credit_card.campaign_id}`
      : ""
    }`;

  const response = yield call(api.post, url, payload);

  if (response.ok) {
    yield put(CreditCardCreators.creditCardSuccess());

    if (payload.credit_card.newCard) {
      yield put(
        MessagesCreators.setMessage(
          "Cartão adicionado com sucesso.",
          "success",
          true
        )
      );
      yield put(SubscriptionCreators.getSubscriptionRequest(0));
      window.location.href = siteParams.download.url;
    } else if (IS_APP) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "subscription",
          success: true,
          message: "Assinatura concluída com sucesso."
        })
      );
    } else {
      yield put(
        MessagesCreators.setMessage(
          "Assinatura concluída com sucesso.",
          "success",
          true
        )
      );
      window.location.href = siteParams.download.url;
    }
  } else if (IS_APP) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: "subscription",
        success: false,
        message: formatter(response.data)
      })
    );
    yield put(CreditCardCreators.creditCardError());
  } else {
    yield put(CreditCardCreators.creditCardError());
    yield put(MessagesCreators.setMessage(formatter(response.data), "danger"));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/creditCard.js